import Content from "../../../anwendungskonfigurator/components/Content"
import React from "react"
import {styled} from "@mui/material"

const CustomUl = styled("ul")(() => ({
    paddingLeft: "20px",
    margin: "4px"
}))

const UnorderedListContainer = ({container}) => {
    const {
        children,
    } = container

    return (
        <CustomUl>
            {children.map(child => <li key={child.id}><Content child={child} key={child.id} /></li>)}
        </CustomUl>
    )
}

export default UnorderedListContainer
